import {View} from"./View"
export const Reports =()=>{
  return(
    <View/>
  )
  }